import { CarrierContract } from '~api/carrier_contracts';

import { Card, ListLayout } from '@ingrid/luterkort-react';
import { ShippingLogo } from '@ingrid/react-shipping-logo';

import { useTranslation } from '~src/i18n/use-translation';

import { CarrierProducts } from '../create/carrier-products';

interface Props {
  contract: Pick<CarrierContract, 'carrier_products' | 'schema_id' | 'carrier_name'>;
}

export function Carrier({ contract }: Props) {
  const method = contract.carrier_products?.find(p => p)?.shipping_method;
  const { t } = useTranslation();

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.carrierProduct')}</Card.Header>
      <Card.Content>
        <ListLayout.Column>
          <ListLayout.SubRow>
            <ShippingLogo method={method} width={40} />
            {contract.carrier_name}
          </ListLayout.SubRow>

          <CarrierProducts schemaId={contract.schema_id} />
        </ListLayout.Column>
      </Card.Content>
    </Card.Wrapper>
  );
}
